export const styleMixinPrefix = 'screenwidth';
export const TestIds = {
  screenWidthContainerBg: 'screenWidthContainerBg',
  screenWidthContainerBgCenter: 'screenWidthContainerBgCenter',
} as const;
